import React, { useEffect, useMemo, useState } from "react";
import { View, Text, TouchableOpacity, TextInput } from "react-native";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";

import Colors from "../../../Resources/Color";
import Fonts from "../../../Resources/Fonts";
import ClientStatisticsHeader from "./ClientStatisticsHeader";
import ClientStatisticsChart from "./ClientStatisticsChart";
import ClientStatisticsTable from "./ClientStatisticsTable";
import { useScreenDimensions } from "../../_layout";
import { getClientStatisticsStore } from "./clientStatisticsStoreCache";

const ClientStatistics = observer(({ client }) => {
  const { t, i18n } = useTranslation();
  const { screenSize } = useScreenDimensions();
  const [copied, setCopied] = useState(false);

  const store = useMemo(() => getClientStatisticsStore(client), [client?.id]);

  useEffect(() => {
    if (!store || store.hasAppliedInitialSuggestion) return;

    const alreadyHasTracks = (store?.tracks?.length ?? 0) > 0;
    if (alreadyHasTracks || !store.canAddTrack) {
      store.markInitialSuggestionApplied();
      return;
    }

    const suggestions = store.getSuggestedExerciseDisplayNames(
      t,
      i18n.language
    );
    const firstSuggestion = Array.isArray(suggestions) ? suggestions[0] : null;

    if (firstSuggestion) {
      store.addTrackByDisplayName(firstSuggestion, {
        t,
        language: i18n.language,
        source: "auto-suggestion",
      });

      if ((store?.selectedBlockIds?.length ?? 0) === 0 && store.canAddBlock) {
        const bestBlockId = store.getMostRecentEligibleBlockId({
          t,
          language: i18n.language,
        });
        if (bestBlockId) {
          store.addBlock(bestBlockId, { t, language: i18n.language });
        }
      }
    }

    store.markInitialSuggestionApplied();
  }, [store, t, i18n.language]);

  const debugText = store?.lastDebugText ?? "";
  const hasDebug = debugText.length > 0;

  const copyDebug = async () => {
    try {
      const text = store?.lastDebugText ?? "";
      if (!text) return;

      if (typeof navigator !== "undefined" && navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 900);
    } catch (e) {
      // no-op; user can still select/copy from the text box
    }
  };

  return (
    <View style={{ flex: 1, marginTop: screenSize === "small" ? 12 : 24 }}>
      <ClientStatisticsHeader store={store} />

      <View style={{ marginTop: 12 }}>
        <ClientStatisticsChart store={store} />
      </View>

      <ClientStatisticsTable store={store} />

      {/* <View
        style={{
          padding: 14,
          borderRadius: 14,
          borderWidth: 0.1,
          borderColor: Colors.borderColor,
          backgroundColor: Colors.whiteColor,
          marginTop: 12,
        }}
      >
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <Text style={[Fonts.regular12, { color: Colors.grayColor, flex: 1 }]}>
            Debug (latest interaction)
          </Text>
          <TouchableOpacity onPress={copyDebug} disabled={!hasDebug}>
            <View
              style={{
                height: 30,
                paddingHorizontal: 10,
                borderRadius: 10,
                borderWidth: 1,
                borderColor: Colors.grayColor,
                alignItems: "center",
                justifyContent: "center",
                opacity: hasDebug ? 1 : 0.4,
              }}
            >
              <Text style={{ fontSize: 12, color: Colors.grayColor }}>
                {copied ? "Copied" : "Copy"}
              </Text>
            </View>
          </TouchableOpacity>
        </View>

        <TextInput
          value={
            hasDebug
              ? debugText
              : "Interact with blocks/tracks to generate debug output."
          }
          editable={false}
          multiline
          style={{
            marginTop: 10,
            borderWidth: 1,
            borderColor: Colors.borderColor,
            borderRadius: 12,
            padding: 10,
            minHeight: 160,
            fontSize: 12,
            color: Colors.grayColor,
            outlineStyle: "none",
          }}
        />
      </View> */}
    </View>
  );
});

export default ClientStatistics;
